// src/items/ParticleEarth.js
import * as THREE from 'three';
import { useFrame, useThree } from '@react-three/fiber';
import { useEffect, useMemo, useRef } from 'react';
import ModularParticleSystem from '../three_particle/ThreeParticle';

// 导入后期处理相关
import { EffectComposer, Bloom, DepthOfField, Vignette } from '@react-three/postprocessing';
import { BlendFunction } from 'postprocessing';

// Convert atmosphere.ts to JS for compatibility
// atmosphere.js content:
class AddonsBasic {
  constructor() {
    this.Geometry = undefined;
    this.update = undefined;
    this.ChangeModel = undefined;
  }
}

const textureLoader = new THREE.TextureLoader();
textureLoader.crossOrigin = '';

const pointMaterial = new THREE.PointsMaterial({
  size: 0.03,
  map: textureLoader.load(process.env.PUBLIC_URL + "/gradient.png"),
  blending: THREE.AdditiveBlending,
  depthWrite: false,
  transparent: true
});

function getRangeRandom(min, max) {
  return Math.random() * (max - min) + min;
}

class AtmosphereParticleClass extends AddonsBasic {
  constructor(options) {
    super();
    const { longestDistance, particleSum, renderUpdate, onChangeModel, callback } = options;
    this.longestDistance = longestDistance;
    this.particleSum = particleSum;
    this.renderUpdate = renderUpdate;
    this.onChangeModel = onChangeModel;
    this.callback = callback;

    const vertices = [];
    for (let i = 0; i < this.particleSum; i++) {
      const x = getRangeRandom(-1 * longestDistance, longestDistance);
      const y = getRangeRandom(-1 * longestDistance, longestDistance);
      const z = getRangeRandom(-1 * longestDistance, longestDistance);
      vertices.push(x, y, z);
    }
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    this.Geometry = new THREE.Points(geometry, pointMaterial);
    if (callback) callback(this.Geometry);
  }

  update = () => {
    if (this.renderUpdate) this.renderUpdate(this.Geometry);
  }

  ChangeModel = () => {
    if (this.onChangeModel) this.onChangeModel(this.Geometry);
  }
}

function ParticleTree({ particleImageUrl, objModelUrl, modelScale }) {
  const { scene, gl, camera } = useThree();
  const groupRef = useRef();
  const composerRef = useRef();

  // Create atmosphere addon
  const atmosphere = useMemo(() => {
    return new AtmosphereParticleClass({
      longestDistance: modelScale * 1.5,
      particleSum: 500,
      renderUpdate: (points) => {
        points.rotation.y += 0.0005;
      },
      onChangeModel: (points) => {
        // Optional: Handle model change
      },
      callback: (points) => {
        // Optional: Initial setup
      }
    });
  }, [modelScale]);

  // Create particle system
  const particleSystem = useMemo(() => {
    const system = new ModularParticleSystem({
      particleTextureUrl: particleImageUrl,
      addons: [atmosphere],
      showDebug: false,
      autoStart: true,
      AnimateDuration: 1500,
      enableMouseFollowX:false,
      onModelsFinishedLoad: (particle, sys) => {
        sys.changeModel('tree');
      },
      models: [
        {
          name: 'tree',
          path: objModelUrl,
          scale: modelScale,
          NeedRemoveDuplicateParticle: true,
          translate: { x: 0, y: 0, z: 0 },
          rotate: { x: 0, y: 0, z: 0 },
          onEnterStart: () => {
            // Optional
          },
          onEnterEnd: () => {
            // Optional
          },
          onAnimationFrameUpdate: (effectParticle, animeMap, geometry) => {
            return true;
          }
        }
      ]
    });

    system.listenMouseMove();

    return system;
  }, [particleImageUrl, objModelUrl, modelScale, atmosphere]);

  useEffect(() => {
    if (groupRef.current && particleSystem) {
      groupRef.current.add(particleSystem);
    }

    return () => {
      if (groupRef.current && particleSystem) {
        groupRef.current.remove(particleSystem);
        particleSystem.dispose();
      }
    };
  }, [particleSystem]);

  // Update in render loop
  useFrame((state, delta) => {
    if (particleSystem) {
      particleSystem.update(delta);
    }
    
    // 更新后期处理合成器
    if (composerRef.current) {
      composerRef.current.render(delta);
    }
  }, 1); // 设置为 render priority 1，确保在默认渲染之后执行

  return (
    <>
      {/* 主场景对象 */}
      <group ref={groupRef} />
      
      {/* 后期处理效果 */}
      <EffectComposer ref={composerRef} multisampling={1} stencilBuffer={true}>

        {/* <Bloom
          intensity={1.2} // 强度
          luminanceThreshold={0} // 亮度阈值
          luminanceSmoothing={0.5} // 平滑度
          mipmapBlur={true} // 使用mipmap进行模糊
          radius={0.8} // 模糊半径
          blendFunction={BlendFunction.ADD} // 混合模式
          kernelSize={0.5} // 内核大小
        /> */}
        

      </EffectComposer>
    </>
  );
}

export default ParticleTree;